export type Point = {
  x: number,
  y: number,
}

export class Rect {

  topLeft: Point;
  bottomRight: Point;

  add(x: number, y: number) {
    if (!this.topLeft) {
      this.topLeft = {x, y};
    }
    if (x < this.topLeft.x) {
      this.topLeft.x = x;
    }
    if (y < this.topLeft.y) {
      this.topLeft.y = y;
    }
    if (!this.bottomRight) {
      this.bottomRight = {x, y};
    }
    if (x > this.bottomRight.x) {
      this.bottomRight.x = x;
    }
    if (y > this.bottomRight.y) {
      this.bottomRight.y = y;
    }
  }

  width(): number {
    return this.bottomRight.x - this.topLeft.x;
  }

  height(): number {
    return this.bottomRight.y - this.topLeft.y;
  }
}